module.exports = __webpack_public_path__ + "img/internet.da18ae57.png";